<div class="db-security__panel-row sl-issue-item">
  <div>
    <span class="db-security-checkbox">
      <label class="db-fc-checkbox"><input id="productItem_{{securityIssue.id}}" type="checkbox" [(ngModel)]="securityIssue.selected" (change)="onItemToggled(activeTab)"><span><i class="db-icon db-icon-check"></i></span></label>
    </span>
    <div class="file-path">
      <div>
        <a class="db-link sl-restore-issue-file-link" *ngIf="activeTab === 'issues'" (click)="restoreFileFn()">{{securityIssue.fileName}}</a>
        <span *ngIf="activeTab === 'ignoredIssues'">{{securityIssue.fileName}}</span>
      </div>
      <div>{{securityIssue.file_path}}</div>
    </div>
    <div class="file-issue" *ngIf="activeTab === 'issues'">{{securityIssue.status}}</div>
    <div class="file-issue" *ngIf="activeTab === 'ignoredIssues'">{{securityIssue.updateDate | dbDate : 'dd MMM y, HH:mm:ss'}}</div>
    <div class="file-action">
      <a class="db-link sl-ignore-issue-button" (click)="doActionFn()" *ngIf="issueIds && !issueIds.includes(securityIssue.file_path) && !loading">{{activeTab === 'issues' ? 'Ignore' : 'Restore'}}</a>
      <db-loading-circular-spinner class="sl-ignore-issue-progress" color="blue" *ngIf="(issueIds && issueIds.includes(securityIssue.file_path)) || loading"></db-loading-circular-spinner>
    </div>
  </div>
</div>
